<template>
  <component
    :is="componentIs"
    :id="id"
    :tracking="tracking"
    :class="btnClasses"
    :active="active"
    :target="target"
    v-bind="bind"
    @click.native="handleClick"
  >
    <slot
      name="label"
      v-bind="{ label }"
    >
      <span class="ah-menu-item__label">{{ label }}</span>
    </slot>
  </component>
</template>
<script>
  import AhLink from '../../atoms/AhLink/AhLink.vue';
  import AhButton from '../../atoms/AhButton/AhButton.vue';
  import { LINK_NEW_WINDOW } from '../../../constants/wording';
  const VARIATIONS = ['medium', 'menu-item', 'large', 'action', 'tab', 'more', 'back'];
  export default {
    name: 'AhMenuItem',
    components: {
      AhLink,
      AhButton,
    },
    inject: {
      $lang: {
        default: () => function() { return 'en'; },
      }
    },
    props: {
      label: {
        type: String,
        default: '',
      },
      tracking: {
        type: String,
        default: '',
      },
      url: {
        type: [String, Object],
        default: null,
      },
      variation : {
        type    : String,
        default : 'menu-item',
        validator(value) {
          return VARIATIONS.indexOf(value) !== -1;
        }
      },
      active: {
        type: Boolean,
        default: false,
      },
      target: {
        type: String,
        default: null,
      },
      id: {
        type:String,
        default: null
      },
    },
    computed: {
      btnClasses() {
        return [
          'ah-link-button',
          this.variation ? `ah-link-button--${this.variation}` : ''
        ];
      },
      bind() {
        const bind = {};
        if (this.url) {
          bind.url = this.url;
        }
        if (this.title) {
          bind.title = this.title;
        }
        return bind;
      },
      componentIs() {
        return this.url ? 'AhLink' : 'AhButton';
      },
      title() {
        if (this.url && this.target === '_blank') {
          return `${this.label} - ${LINK_NEW_WINDOW[this.lang] || LINK_NEW_WINDOW['en']}`;
        }
        return null;
      },
      lang() {
        return this.$lang();
      }
    },
    methods: {
      handleClick () {
        this.$emit('clicked', { tracking: this.tracking });
      }
    }
  };
</script>
